import { render } from "./logs-view-detail-page.vue?vue&type=template&id=4ce659c1"
import script from "./logs-view-detail-page.vue?vue&type=script&lang=ts"
export * from "./logs-view-detail-page.vue?vue&type=script&lang=ts"

import "./logs-view-detail-page.vue?vue&type=style&index=0&id=4ce659c1&lang=less"
script.render = render

export default script